import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VideocamIcon from '../../../../../../components/Icons/VideocamIcon';
import { fileIsImage, fileIsVideo } from '../../../../../../utils/FileUtils';
import styles from './Documento.scss';

const rootClassName = styles.rootClassName;

class Documento extends Component {
  render() {
    const allProps = {
      className:
        rootClassName +
        (fileIsImage(this.props.url) ? ' ' + rootClassName + '-image' : ''),
      href: this.props.url,
      target: '_blank',
      style: fileIsImage(this.props.url)
        ? {
            backgroundImage: 'url(' + this.props.url + ')',
          }
        : {},
    };
    return (
      <>
        <a {...allProps}>
          {fileIsVideo(this.props.url) ? (
            <VideocamIcon className={rootClassName + '-video-icon'} />
          ) : (
            ''
          )}
          {fileIsImage(this.props.url) ? (
            <img
              className={rootClassName + '-print'}
              src={this.props.url}
              alt='icone-arquivo' 
              loading='lazy'
            />
          ) : (
            ''
          )}
        </a>
      </>
    );
  }
}

Documento.propTypes = {
  url: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Documento);
